import { render, staticRenderFns } from "./furnitureshop-grid-slider-02.vue?vue&type=template&id=0c99a220&scoped=true&"
import script from "./furnitureshop-grid-slider-02.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-grid-slider-02.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-grid-slider-02.vue?vue&type=style&index=0&id=0c99a220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99a220",
  null
  
)

export default component.exports